const search = () => {
    const openSearch = document.querySelectorAll(".js-open-search");
    const closeSearch = document.querySelectorAll(".js-close-search");
    const searchPopup = document.querySelector(".search");

    for (var i = 0; i < openSearch.length; i++) {
        openSearch[i].addEventListener("click", function(e){
            if (searchPopup) {
                searchPopup.classList.add("open");
            }
        });
    }

    for (var i = 0; i < closeSearch.length; i++) {
        closeSearch[i].addEventListener("click", function(e){
            if (searchPopup) {
                searchPopup.classList.remove("open");
            }
        });
    }
}

export default search;
